import { User } from "@acto/taskpane/core/domain";
import { useAssignableUsers } from "@acto/taskpane/field-sales-2/data-access/todos/useAssignableUsers";

interface UseAssigneeToggleResult {
  users: User[];
  isFetching: boolean;
  /** The offered entry matching [currentAssignee], for the picker's selection highlight. */
  selectedId: string | undefined;
  /**
   * Disabled while unverified (the assignable-users fetch is in flight), with nobody to assign, or
   * with exactly one candidate who is already the current assignee — opening the picker would offer
   * no other option.
   */
  disabled: boolean;
}

/** State for an assignee row that opens the picker. */
export function useAssigneeToggle(
  clientId: string | undefined,
  currentAssignee: { id: string } | null | undefined,
): UseAssigneeToggleResult {
  const { users, isFetching } = useAssignableUsers(clientId);

  const selectedId = currentAssignee?.id;
  const disabled = isFetching || users.length === 0 || (users.length === 1 && users[0].id === selectedId);

  return { users, isFetching, selectedId, disabled };
}
